export const _REVIEWS = {
    SUBMIT_REVIEW_REQUEST : 'SUBMIT_REVIEW_REQUEST',
    SUBMIT_REVIEW_SUCCESS : 'SUBMIT_REVIEW_SUCCESS',
    SUBMIT_REVIEW_FAILURE : 'SUBMIT_REVIEW_FAILURE',

    FETCH_REVIEWS_REQUEST : 'FETCH_REVIEWS_REQUEST',
    FETCH_REVIEWS_SUCCESS : 'FETCH_REVIEWS_SUCCESS',
    FETCH_REVIEWS_FAILURE : 'FETCH_REVIEWS_FAILURE',

    FETCH_AGENT_REVIEWS_REQUEST : "FETCH_AGENT_REVIEWS_REQUEST",
    FETCH_AGENT_REVIEWS_SUCCESS : "FETCH_AGENT_REVIEWS_SUCCESS",
    FETCH_AGENT_REVIEWS_FAILURE : "FETCH_AGENT_REVIEWS_FAILURE",
    
    REPORT_USER_REQUEST: "REPORT_USER_REQUEST",
    REPORT_USER_SUCCESS: "REPORT_USER_SUCCESS",
    REPORT_USER_FAILURE: "REPORT_USER_FAILURE",

    EDIT_REVIEW_REQUEST: "EDIT_REVIEW_REQUEST",
    EDIT_REVIEW_SUCCESS: "EDIT_REVIEW_SUCCESS",
    EDIT_REVIEW_FAILURE: "EDIT_REVIEW_FAILURE",

    DELETE_REVIEW_REQUEST: "DELETE_REVIEW_REQUEST",
    DELETE_REVIEW_SUCCESS: "DELETE_REVIEW_SUCCESS",
    DELETE_REVIEW_FAILURE: "DELETE_REVIEW_FAILURE",
}